// extracted by mini-css-extract-plugin
export default {"textLink":"IndexTableManagementTable_textLink__aWXT8"};